import _ from 'lodash';
import { Factory } from 'rosie';

import '../conversation_item_factory';

Factory.define('RoutingItem').attr('type', 'ROUTING_ITEM');

Factory.define('RoutingItemForAgentRequest')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'AGENT_REQUEST' }, content));
  });

Factory.define('RoutingItemForAutomatedAssignment')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'AUTOMATED_ASSIGNMENT' }, content));
  });

Factory.define('RoutingItemForBlindTransfer')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'BLIND_TRANSFER' }, content));
  });

Factory.define('RoutingItemForDeclinedChat')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'DECLINED_CHAT' }, content));
  });

Factory.define('RoutingItemForIncomingCall')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'INCOMING_CALL' }, content));
  });

Factory.define('RoutingItemForIncomingChat')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'INCOMING_CHAT' }, content));
  });

Factory.define('RoutingItemForIncomingEmail')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'INCOMING_EMAIL' }, content));
  });

Factory.define('RoutingItemForIncomingFbMessage')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'INCOMING_FB_MESSAGE' }, content));
  });

Factory.define('RoutingItemForIncomingSMS')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'INCOMING_SMS' }, content));
  });

Factory.define('RoutingItemForIncomingTask')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'INCOMING_TASK' }, content));
  });

Factory.define('RoutingItemForManualAssignment')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'MANUAL_ASSIGNMENT' }, content));
  });

Factory.define('RoutingItemForMissedChat')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'MISSED_CHAT' }, content));
  });

Factory.define('RoutingItemForOfferConflict')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'OFFER_CONFLICT' }, content));
  });

Factory.define('RoutingItemForOutgoingCall')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'OUTGOING_CALL' }, content));
  });

Factory.define('RoutingItemForOutgoingEmail')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'OUTGOING_EMAIL' }, content));
  });

Factory.define('RoutingItemForOutgoingFbMessage')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'OUTGOING_FB_MESSAGE' }, content));
  });

Factory.define('RoutingItemForOutgoingSMS')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'OUTGOING_SMS' }, content));
  });

Factory.define('RoutingItemForSlaUpdate')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'SLA_UPDATE' }, content));
  });

Factory.define('RoutingItemForVoicemail')
  .extend('ConversationItem')
  .attr('content', ['content'], function(content) {
    return Factory.attributes('RoutingItem', _.merge({ itemType: 'VOICEMAIL' }, content));
  });



// WEBPACK FOOTER //
// ./factories/conversation_items/routing_item_factory.js